import { DRAFTS } from '../../constants/gates';
import { useGate } from '../useGate';
export const useIsUngatedForDrafts = () => useGate(DRAFTS);